import { useNuxtApp } from "#imports";
const getAuth0Client = (nuxtApp) => {
  const auth0 = nuxtApp.$auth0;
  if (auth0 && typeof auth0 === "function") {
    return auth0();
  }
  return null;
};
const getTokenFromAuth0 = async (client) => {
  try {
    return await client.getAccessTokenSilently();
  } catch {
    return null;
  }
};
const getTokenFromSession = async (nuxtApp) => {
  try {
    const $fetch = nuxtApp.$fetch;
    if (!$fetch || typeof $fetch !== "function") return null;
    const response = await $fetch("/api/auth/session");
    const session = response?.data ?? response;
    return session?.accessToken ?? null;
  } catch {
    return null;
  }
};
export const useAuthAdapter = () => {
  const nuxtApp = useNuxtApp();
  const getAccessToken = async () => {
    const auth0Client = getAuth0Client(nuxtApp);
    if (auth0Client) {
      const token2 = await getTokenFromAuth0(auth0Client);
      if (token2) return token2;
    }
    const token = await getTokenFromSession(nuxtApp);
    if (token) return token;
    return null;
  };
  const isAuthenticated = async () => {
    const auth0Client = getAuth0Client(nuxtApp);
    if (auth0Client?.isAuthenticated?.value) {
      return true;
    }
    const sessionToken = await getTokenFromSession(nuxtApp);
    return sessionToken !== null;
  };
  return {
    getAccessToken,
    isAuthenticated
  };
};
